/**
 * Filtro client-side puro para o modal SeletorConjuntos.
 *
 * Gemeo de `filtrarUsinasEolicas.ts` adaptado ao shape de
 * `ConjuntoAgregado`: predicado unico, Sets pre-construidos para O(1)
 * em multi-select, alocacao apenas do array final.
 *
 * Operacao em ~156 itens × 5 predicados = ~780 comparacoes por re-render —
 * imperceptivel mesmo em CPU lenta. Memo no consumidor evita recomputo.
 */
import { ConjuntoAgregado, FiltrosConjuntos } from 'helper/windx';

export default function filtrarConjuntos(
  conjuntos: ConjuntoAgregado[],
  filtros: FiltrosConjuntos,
): ConjuntoAgregado[] {
  const busca = filtros.busca.trim().toLowerCase();
  const temBusca = busca.length > 0;
  const ufsSet = filtros.ufs.length > 0 ? new Set(filtros.ufs) : null;
  const subsmSet = filtros.subsistemasSm.length > 0
    ? new Set(filtros.subsistemasSm)
    : null;
  const subshSet = filtros.subsistemasSh.length > 0
    ? new Set(filtros.subsistemasSh)
    : null;
  const epeSet = filtros.localizacoesEpe.length > 0
    ? new Set(filtros.localizacoesEpe)
    : null;

  return conjuntos.filter((c) => {
    if (ufsSet) {
      if (!c.uf_sigla || !ufsSet.has(c.uf_sigla)) return false;
    }
    if (subsmSet) {
      if (!c.subsistema_sm_sigla || !subsmSet.has(c.subsistema_sm_sigla)) return false;
    }
    if (subshSet) {
      if (!c.subsistema_sh_sigla || !subshSet.has(c.subsistema_sh_sigla)) return false;
    }
    if (epeSet) {
      if (!c.localizacao_epe || !epeSet.has(c.localizacao_epe)) return false;
    }
    if (temBusca) {
      // WINDX-024: busca casa em cod_conjunto OU ponto_de_conexao OU label.
      // `label` ja contem cod_conjunto como prefixo, mas mantemos os 3 para
      // ergonomia (digitar "Coxilha" e "rsecn4" ambos funcionam).
      const codMatch = c.cod_conjunto.toLowerCase().includes(busca);
      const pontoMatch = c.ponto_de_conexao.toLowerCase().includes(busca);
      const labelMatch = c.label.toLowerCase().includes(busca);
      if (!codMatch && !pontoMatch && !labelMatch) return false;
    }
    return true;
  });
}
